module.exports = __webpack_public_path__ + "img/Sandeep.4770dc30.png";